import { render, staticRenderFns } from "./v-dialog-select.vue?vue&type=template&id=9f83f42c&scoped=true&"
import script from "./v-dialog-select.vue?vue&type=script&lang=js&"
export * from "./v-dialog-select.vue?vue&type=script&lang=js&"
import style0 from "./v-dialog-select.vue?vue&type=style&index=0&id=9f83f42c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f83f42c",
  null
  
)

export default component.exports